import { css } from '@emotion/react'
import { Theme } from '../settings/theme'

export const Base = css`
  body {
    font-family: 'Open Sans', sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: ${Theme.colors.black};
    text-align: left;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 0.5rem;
    font-weight: 700;
    margin-top: 0;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    &:hover,
    &:active,
    &:focus {
      text-decoration: underline;
    }
  }
`
